import React from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import {setArticleCreator} from '../Store/Articles/Actions';

interface ArticleLinkProps {
  id: number;
  children?: React.ReactNode;

  setArticle: (id: number) => Promise<void>;
}

function ArticleLink({id, setArticle, children}: ArticleLinkProps)  {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setArticle(id);
    window.scrollTo(0, 0);
  };

  return (
    <a href={`/public/article/${id}`} className="headline" onClick={handleClick}>
      {children}
    </a>
  );
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setArticle: (id: number) => dispatch(setArticleCreator(id)),
  };
};

export default connect(null, mapDispatchToProps)(ArticleLink);
